/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferInDescription
 */
export interface OfferInDescription {
    /**
     * 
     * @type {string}
     * @memberof OfferInDescription
     */
    description: string;
}

export function OfferInDescriptionFromJSON(json: any): OfferInDescription {
    return OfferInDescriptionFromJSONTyped(json, false);
}

export function OfferInDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferInDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
    };
}

export function OfferInDescriptionToJSON(value?: OfferInDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
    };
}


